import * as tslib_1 from "tslib";
import React from 'react';
import { Icon } from 'office-ui-fabric-react/lib';
import { assertNever } from 'owa-assert';
import TextSegmentPart from './TextSegmentPart';
import PeopleSegmentPart from './PeopleSegmentPart';
var styles = require('../SearchBoxPillWell.scss');
var classNames = require('classnames/bind');
var SuggestionSegment = /** @class */ (function (_super) {
    tslib_1.__extends(SuggestionSegment, _super);
    function SuggestionSegment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SuggestionSegment.prototype.getSegmentPart = function () {
        var segment = this.props.segment;
        switch (segment.Type) {
            case 'Text':
                return {
                    key: segment.DisplayText,
                    containerClassNames: [styles.textSegment],
                    element: React.createElement(TextSegmentPart, { segment: segment }),
                };
            case 'Person':
                return {
                    key: segment.EmailAddress,
                    containerClassNames: null,
                    element: (React.createElement(PeopleSegmentPart, { name: segment.DisplayName, emailAddress: segment.EmailAddress, personaType: 'User' })),
                };
            default:
                return assertNever(segment);
        }
    };
    SuggestionSegment.prototype.render = function () {
        var _a = this.props, index = _a.index, onRemoveSegment = _a.onRemoveSegment;
        var segmentPart = this.getSegmentPart();
        var pillContainerClasses = classNames(segmentPart.containerClassNames || styles.segmentContainerCommon, (_b = {},
            _b[styles.segmentWithoutRemoveIcon] = !onRemoveSegment,
            _b));
        return (React.createElement("div", { key: segmentPart.key, className: pillContainerClasses },
            segmentPart.element,
            onRemoveSegment && (React.createElement(Icon, { styles: {
                    root: [styles.removeIconCommon, styles.cancelIcon],
                }, iconName: "Cancel" /* Cancel */, onClick: function () { return onRemoveSegment(index); } }))));
        var _b;
    };
    return SuggestionSegment;
}(React.Component));
export { SuggestionSegment };
//# sourceMappingURL=SuggestionSegment.js.map